// extracted by mini-css-extract-plugin
export default {"header":"OrderStoryPage_header__wXnd3","title_block":"OrderStoryPage_title_block__KnyGR","orders_container":"OrderStoryPage_orders_container__mVMYG"};